const locale = require('./accountSubmissions.i18n.json');

/*@ngInject*/
const AccountSubmissionsGridController = function ($scope, $controller, $stateParams, $state, $rootScope, advancedFilterType,
                                                                  appTypeConfigurationModel, coreConstant, landingConstant, submissionGridConstant, gridColumnModel,
                                                                  persistentConnection, submissionMediator) {

    angular.extend(this, $controller('baseSubmissionGridController', {$scope: $scope}));

    let accountSubmissionParams = {
        key: 'effectiveDate',
        startIndex: 0,
        pageSize: 25,
        sortType: 'asc',
        searchString: '',
        filterUri: ''
    };

    this.i18n = locale;

    this.isColumnFilterVisible = true;
    this.isGridFilterVisible = false;
    this.isViewActiveVisible = true;
    this.isSearchVisible = true;
    this.isGridPagingVisible = true;
    this.isGridInteractable = true;
    this.selectedSubmissionId = parseInt($stateParams.submissionId);
    this.advancedFilterType = advancedFilterType.ACCOUNT_SUBMISSIONS_GRID;

    this.$onInit = function () {
        if (this.gridColumnsPreference) {
            this.columnPreference = this.gridColumnsPreference;
        } else {
            this.columnPreference = this.isAgent ? 'system.accountOverviewSubmissionColumnsForAgent' : 'system.accountOverviewSubmissionColumnsForUnderwriter';
        }
        this.initSubmissionGrid();
    };

    this.updateFilterFromPreferences = function () {
        $scope.$broadcast(submissionGridConstant.event.RESET_GRID_LIST);
    };

    this.onPagingChange = function ($event, params) {
        this.requestParams.pageSize = params.pageSize;
        this.requestParams.startIndex = params.startIndex;
        this.loadGrid();
    };

    this.loadRecords = function (onSuccess, onError) {
        this.accountId = this.accountId || $stateParams.accountId;
        submissionMediator.loadAccountSubmissions(this.accountId, this.accountNumber, this.requestParams).then(function (records) {
            onSuccess(records);
            this.selectAllCheckBoxes();
        }.bind(this), onError);
    };

    this.areAllRecordsSelected = function () {
        let allSelected = true;
        _.each(this.records, function (record) {
            if (this.isShowCheckBox(record) && !record.checkboxSelected) {
                allSelected = false;
            }
        }.bind(this));
        return allSelected;
    };

    this.selectAllCheckBoxes = function () {
        let allSelected = this.areAllRecordsSelected();
        _.each(this.records, function (record) {
            if (this.isShowCheckBox(record)) {
                this.doPoliciesExistOnSubmissions({doPoliciesExist: true});
                record.checkboxSelected = !allSelected;
                this.setSelectedCheckboxItem(null, record);
            }
        }.bind(this));
    };

    this.setFilterParams = function (filterParams) {
        accountSubmissionParams = filterParams;
        $rootScope.$broadcast(coreConstant.event.SUBMISSION_FILTER_CHANGED, filterParams);
    };

    this.getFilterParams = function () {
        return accountSubmissionParams;
    };

    this.resetParams = function (params) {
        accountSubmissionParams = params;
    };

    this.openSubmission = _.debounce(function (submission) {
        if (this.isGridInteractable) {
            if (!_.isNil(submission.id) && submission.id > 0) {
                if (submission.id === parseInt($stateParams.submissionId)) {
                    return;
                }

                if (this.isColSelectDropdownOpen) {
                    $scope.updateDropdownClosed();
                    return;
                }
                if (!this.isSearchOpen) {
                    gridColumnModel.setOpenFilterUri(null);
                }

                let submissionId = submission.id,
                    params = {submissionId: submissionId},
                    stateName = 'submission.form';

                this.isLoading = true;
                $state.go(stateName, params);
            }
        }
    }.bind(this), 200, {leading: true});

    this.setSelectedCheckboxItem = function (event) {
        if (this.isGridInteractable) {

            this.selectedSubmissionIds = [];

            _.forEach(this.records, function (item) {
                if (item.checkboxSelected) {
                    this.selectedSubmissionIds.push(item.id);
                }
            }.bind(this));
            if (event) {
                event.stopPropagation();
            }
            this.allCheckBoxesSelected = this.areAllRecordsSelected();
            this.onSelectedSubmissionsChanged({items: this.selectedSubmissionIds});

        }
    }.bind(this);

    this.setSelectedItem = function (event, selectedItem) {
        if (this.isGridInteractable) {
            $scope.$broadcast(submissionGridConstant.event.CLOSE_SUBMISSION_DETAIL_DRAWER);

            if (selectedItem.selected) {
                selectedItem.selected = false;
                this.isDrawerOpen = false;
                return;
            }

            if ($(event.currentTarget).hasClass('toggleDrawer')) {
                this.isDrawerOpen = true;
            }

            _.forEach(this.records, function (item) {
                item.selected = (item === selectedItem);
            });

            if (!_.isNil(selectedItem.id) && selectedItem.id > 0) {
                $scope.$broadcast(submissionGridConstant.event.OPEN_SUBMISSION_DETAIL_DRAWER);
            }
        }
    }.bind(this);

    this.showCheckboxes = function () {
        let showCheckboxes = false;
        _.each(this.records, function (record) {
            if (this.isShowCheckBox(record)) {
                showCheckboxes = true;
            }
        }.bind(this));
        return showCheckboxes;
    };

    this.isShowCheckBox = function (submission) {
        return this.isShowCheckboxes && submission.policyNumber && submission.id;
    };

    this.getStatus = function(item) {
        return _.get(this.i18n, 'status.' + item.status);
    }

    $scope.$on(submissionGridConstant.event.RESET_GRID_COLUMNS, function () {
        this.updateColumnsFromPreferences();
        this.resetGridColumns();
    }.bind(this));

    $scope.$on(coreConstant.event.DATAGRID_ON_RESET_HEADERS, function (evt, params) {
        this.resetParams(params);
        if (this.isLoaded) {
            this.loadGrid();
        }
    }.bind(this));

    $scope.$on(coreConstant.event.USERTYPE_UPDATED, function () {
        persistentConnection.connect().then(function () {
            this.isUserTypeUpdated = true;
            this.isAgent = appTypeConfigurationModel.isAgentConsole();
            this.initLandingPage();
        }.bind(this));
    }.bind(this));

    $scope.$on(coreConstant.event.FILTER_SAVED, this.handleFilterSave.bind(this));
};

angular.module('gw-um-submission')
    .controller('accountSubmissionsGridController', AccountSubmissionsGridController);
